import React, { useState, useRef } from "react";
import SupportBanner from "../Components/SupportBanner";
import emailjs from "@emailjs/browser";
import { toast } from "react-hot-toast";

export default function ContactPage() {
  const formRef = useRef(null);
  const [sending, setSending] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setSending(true);

    emailjs.init("slCDG9KliU1w0z5lI");

    try {
      await emailjs.sendForm(
        'service_vsfs2w8',
        'template_o8rhpbn',
        e.target
      );

      toast.success("Köszönjük! Üzenetét elküldtük. 😊");
      formRef.current.reset();
    } catch (err) {
      console.error(err);
      toast.error("Hoppá! Nem sikerült elküldeni. Próbáld újra.");
    } finally {
      setSending(false);
    }
  }

  return (
    <><main>
          {/* 1️⃣  Hero */}
          <section className="relative h-[60vh] w-full overflow-hidden">
              <img
                  src="/contact/hero.jpg"
                  alt="Balaton Táncegyüttes"
                  className="absolute inset-0 h-full w-full object-cover object-center" />
              <div className="absolute inset-0 bg-black/40" />

              {/* Overlay kártya */}
              <div className="relative z-10 mx-auto mt-24 max-w-xl rounded-md bg-blue-900/80 p-8 text-white backdrop-blur-sm">
                  <h1 className="mb-4 text-3xl font-bold">Balaton Táncegyüttes</h1>
                  <ul className="space-y-1 text-sm leading-relaxed">
                      <li>
                          <span className="font-semibold">Levelezési cím:</span> 8600
                          Siófok, Szépvölgyi utca 2.
                      </li>
                      <li>
                          <span className="font-semibold">Email:</span>{" "}
                          <a href="mailto:info@balatonte.hu" className="underline">
                              info@balatonte.hu
                          </a>
                      </li>
                      <li>
                          <span className="font-semibold">Facebook:</span>{" "}
                          <a
                              href="https://www.facebook.com/Balaton.Tancegyuttes/"
                              target="_blank"
                              rel="noreferrer"
                              className="underline"
                          >
                              Balaton Táncegyüttes
                          </a>
                      </li>
                  </ul>
              </div>
          </section>

          {/* 2️⃣  Form + Map */}
          <section className="mx-auto max-w-6xl grid gap-10 px-4 py-16 md:grid-cols-2">
              {/* Form */}
              <form ref={formRef} onSubmit={handleSubmit} className="space-y-4">
                  <input
                      type="text"
                      name="user_nev"
                      placeholder="Név"
                      required
                      className="w-full rounded-md border px-3 py-2" />
                  <input
                      type="email"
                      name="user_email"
                      placeholder="E-mail"
                      required
                      className="w-full rounded-md border px-3 py-2" />
                  <input
                      type="tel"
                      name="user_phone"
                      placeholder="Telefonszám (opcionális)"
                      className="w-full rounded-md border px-3 py-2" />
                  <textarea
                      name="targy"
                      rows={4}
                      placeholder="Üzenet"
                      required
                      className="w-full rounded-md border px-3 py-2" />

                  <label className="flex items-center gap-2 text-sm">
                      <input type="checkbox" required className="h-4 w-4" />
                      Elolvastam és elfogadom az {" "}
                      <a
                          href="/privacy-policy"
                          className="underline text-primary"
                          target="_blank"
                          rel="noreferrer"
                      >
                          adatvédelmi tájékoztatót
                      </a>
                  </label>

                  <button
                    type="submit"
                    disabled={sending}
                    className="self-start rounded-md bg-rose-600 px-4 py-2 text-sm font-medium text-white hover:bg-rose-700 disabled:opacity-50"
                    >
                        {sending ? "Küldés…" : "Küldés"}
                  </button>
              </form>

              {/* Google Map iframe */}
              <iframe src="https://maps.google.com/maps?q=8600%20Siófok%2C%20Szépvölgyi%20utca%202&z=17&output=embed" title="Balaton Táncegyüttes – Szépvölgyi u. 2." width="600" height="450" loading="lazy" className="h-96 w-full rounded-md border"></iframe>
          </section>
      </main><SupportBanner /></>
  );
}
